import person01 from '../../img/hero/company-people/person-01.webp';
import person02 from '../../img/hero/company-people/person-02.webp';
import person03 from '../../img/hero/company-people/person-03.webp';
import person04 from '../../img/hero/company-people/person-04.webp';
import person05 from '../../img/hero/company-people/person-05.webp';
import person06 from '../../img/hero/company-people/person-06.webp';
import person07 from '../../img/hero/company-people/person-07.webp';
import person08 from '../../img/hero/company-people/person-08.webp';
import person09 from '../../img/hero/company-people/person-09.webp';
import person10 from '../../img/hero/company-people/person-10.webp';
import person11 from '../../img/hero/company-people/person-11.webp';
import person12 from '../../img/hero/company-people/person-12.webp';
import person13 from '../../img/hero/company-people/person-13.webp';
import person14 from '../../img/hero/company-people/person-14.webp';
import person15 from '../../img/hero/company-people/person-15.webp';
import person16 from '../../img/hero/company-people/person-16.webp';
import person17 from '../../img/hero/company-people/person-17.webp';
import person18 from '../../img/hero/company-people/person-18.webp';
import person19 from '../../img/hero/company-people/person-19.webp';
import person20 from '../../img/hero/company-people/person-20.webp';
import person21 from '../../img/hero/company-people/person-21.webp';
import person22 from '../../img/hero/company-people/person-22.webp';
import person23 from '../../img/hero/company-people/person-23.webp';
import person24 from '../../img/hero/company-people/person-24.webp';
import { companyHeroCopy } from './companyHomeContent.js';
import type { LandingCompanyPeopleHeroContent, LandingLocale } from './landingContentTypes.js';

const people = [
  person01,
  person02,
  person03,
  person04,
  person05,
  person06,
  person07,
  person08,
  person09,
  person10,
  person11,
  person12,
  person13,
  person14,
  person15,
  person16,
  person17,
  person18,
  person19,
  person20,
  person21,
  person22,
  person23,
  person24,
];
const copy: Record<LandingLocale, { intro: string; introActionLabel: string; scrollLabel: string; personAlt: string }> = {
  de: {
    intro: 'Internationale Fachkräfte für deinen Betrieb. Persönlich begleitet bis zum Ankommen.',
    introActionLabel: 'Unternehmenstool entdecken',
    scrollLabel: 'Weiter scrollen',
    personAlt: 'Illustratives Porträt einer erwachsenen Person aus der Türkei',
  },
  en: {
    intro: 'International professionals for your business. Personal support until they settle in.',
    introActionLabel: 'Explore the company tool',
    scrollLabel: 'Scroll to continue',
    personAlt: 'Illustrative portrait of an adult from Turkey',
  },
  tr: {
    intro: 'İşletmen için uluslararası uzmanlar. İlk adımdan ekibine uyum sağlamalarına kadar kişisel destek.',
    introActionLabel: 'İşveren aracını keşfet',
    scrollLabel: 'Devam etmek için kaydır',
    personAlt: 'Türkiye’den yetişkin bir kişinin temsili portresi',
  },
};

export const createCompanyPeopleHeroContent = (locale: LandingLocale): LandingCompanyPeopleHeroContent => {
  const old = companyHeroCopy[locale];
  const local = copy[locale];
  return {
    title: old.title,
    highlight: old.highlight,
    intro: local.intro,
    introAction: { label: local.introActionLabel, href: '#matching-demo' },
    portrait: { ...old.portraits.second },
    primaryAction: { ...old.primaryAction },
    secondaryAction: { ...old.secondaryAction },
    benefits: old.benefits.map(benefit => ({ ...benefit })),
    people: people.map(image => ({ image, imageAlt: local.personAlt })),
    scrollLabel: local.scrollLabel,
    motion: 'subtle',
  };
};
